<template>
  <div>
    <!-- TKP-124: birim → süreç → veri düğümü → ilgili kişi; kaynak kutusu kalktı (kaynak düğümün envanter özelliği) -->
    <department-boxes />
    <process-boxes />
    <data-boxes />
    <datasubject-boxes />
  </div>
</template>

<script>
import DataBoxes from "./data-boxes";
import DatasubjectBoxes from "./datasubject-boxes";
import DepartmentBoxes from "./department-boxes";
import ProcessBoxes from "./process-boxes";
/** TKP-102: Varlıklar kutuları tek bileşende — sayfa sekmeli olunca da, sekmesiz de aynı içerik. */
export default {
  name: "entity-boxes",
  components: { DepartmentBoxes, ProcessBoxes, DataBoxes, DatasubjectBoxes },
};
</script>
